import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import CrmKTP from "../../components/crmKTP";
import CrmTambahan from "../../components/crmTambahan";
import CrmMember from "../../components/crmMember";
import {
    loyaltyLevelOptions,
    memberLevelOptions,
    prospekCategoryOptions,
    prospekSourceOptions,
    prospekTypeOptions, specialCategoryOptions
} from "../../config/constants";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import CrmSystem from "../../components/crmSystem";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import SimpleSpacerLine from "../../../../../modules/SimpleSpacerLine";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {toDetailData, toMapFields} from "../service";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";

class CrmCDBDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            generalAlertVisible: false,
            simpanAlertVisible: false,
            changeRequestAlertVisible: false,
            processAlertVisible: false,
            id: null,
            options: {
                provinceOptions: [],
                kabkotOptions: [],
                kecamatanOptions: [],
                kelurahanOptions: [],
                zipCodeOptions: [],
                zipCodeRaw: [],
                genderOptions: [],
                religionOptions: [],
                hobbyOptions: [],
                interestOptions: [],
                prospekSourceCreateOptions: [],
                jobOptions: [],
                prospekCategoryOptions,
                prospekSourceOptions,
                prospekTypeOptions,
                memberLevelOptions,
                loyaltyLevelOptions,
                specialCategoryOptions,
            },
        }
    }

    componentDidMount = async () => {
        if (!R.isNil(this.props.initialValues)) {
            this.handleTriggerLoading();
            await this.fetchData();
            this.handleTriggerLoading();
        }

        this.setDataOptions("prospekSourceCreateOptions", prospekSourceOptions.slice(1));

        this.fetchDataProvince();
        this.fetchBizpar();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.activityType !== "VIEW") {
            if (prevProps.controls?.provinceId?.value?.value !== this.props.controls.provinceId?.value?.value) {
                this.setDataOptions("kabkotOptions", []);
                this.setDataOptions("kecamatanOptions", []);
                this.setDataOptions("kelurahanOptions", []);
                this.setDataOptions("zipCodeOptions", []);
                this.setDataOptions("zipCodeRaw", []);

                this.props.setValue("kabkotId", "");
                this.props.setValue("kecamatanId", "");
                this.props.setValue("kelurahanId", "");
                this.props.setValue("zipcode", "");
                this.fetchDataKabKot(this.props.controls.provinceId?.value?.value);
            }
            if (prevProps.controls?.kabkotId?.value?.value !== this.props.controls.kabkotId?.value?.value) {
                this.setDataOptions("kecamatanOptions", []);
                this.setDataOptions("kelurahanOptions", []);
                this.setDataOptions("zipCodeOptions", []);
                this.setDataOptions("zipCodeRaw", []);

                this.props.setValue("kecamatanId", "");
                this.props.setValue("kelurahanId", "");
                this.props.setValue("zipcode", "");
                this.fetchDataKecamatan(this.props.controls.kabkotId?.value?.value);
            }
            if (prevProps.controls?.kecamatanId?.value?.value !== this.props.controls.kecamatanId?.value?.value) {
                this.setDataOptions("kelurahanOptions", []);
                this.setDataOptions("zipCodeOptions", []);
                this.setDataOptions("zipCodeRaw", []);

                this.props.setValue("kelurahanId", "");
                this.props.setValue("zipcode", "");
                this.fetchDataKelurahan(this.props.controls.kecamatanId?.value?.value);
            }
            if (prevProps.controls?.kelurahanId?.value?.value !== this.props.controls.kelurahanId?.value?.value && !R.isEmpty(this.state.options.zipCodeRaw)) {
                const data = this.state.options.zipCodeRaw.find(item => item.id === this.props.controls.kelurahanId?.value?.value);
                this.setDataOptions("zipCodeOptions", !R.isEmpty(data) ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []);
            }
        }
    };

    fetchDataProvince = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("provinceOptions", response.data.data.map(item => mapToObjectDDL(item.provinceName, item.id)));

            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKabKot = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kabkotOptions", response.data.data.map(item => mapToObjectDDL(item.kabKotName, item.kabKotId)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKecamatan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kecamatanOptions", response.data.data.map(item => mapToObjectDDL(item.kecamatanName, item.id)));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKelurahan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id)
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setDataOptions("kelurahanOptions", response.data.data.map(item => mapToObjectDDL(item.kelurahanname, item.id)));
                this.setDataOptions("zipCodeRaw", response.data.data);
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchBizpar = async () => {
        const bizparConfigs = [
            {key: "genderOptions", category: "GENDER_TYPE"},
            {key: "religionOptions", category: "RELIGION_TYPE"},
            {key: "hobbyOptions", category: "HOBBY_TYPE"},
            {key: "interestOptions", category: "INTEREST_TYPE"},
            {key: "jobOptions", category: "JOB_TYPE"},
        ];

        const responses = await Promise.all(
            bizparConfigs.map(config =>
                fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                    setError: this.props.setError,
                    menuName: "CRM Management CDB",
                    args: {paramFilters: {bizparCategory: config.category}},
                })
            )
        );

        responses.forEach((response, idx) => {
            const config = bizparConfigs[idx];
            if (response?.data?.status === HttpStatus.SUCCESS) {
                const mappedOptions = response.data.data.map(item => mapToObjectDDL(item.value, item.key));
                this.setDataOptions(config.key, mappedOptions);
            }
        });
    };

    setDataOptions = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            options: {
                ...prevValue.options,
                [name]: value,
            },
        }));
    };

    fetchData = async () => {
        if (this.props.state.activeTab === "create_prospek") {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailCDBManagement,
                setError: this.props.setError,
                menuName: "CRM Management CDB",
                args: contructQueryParam({nik: this.props.controls.nik?.value}),
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                const mapFields = toMapFields(res.data.data);
                mapFields.forEach(({key, value}) => {
                    this.props.setValue(key, value);
                });
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                id: this.props.state?.selectedData?.id,
            }));
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailRequestUpdateById,
                setError: this.props.setError,
                menuName: "CRM Management CDB",
                args: {
                    id: this.props.state?.selectedData?.id
                },
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.props.onSetState((prevState) => ({
                    ...prevState,
                    tempDataChangeRequest: res.data.data,
                    dataChangeRequest: {
                        dataBefore: toDetailData(res.data.data?.dataBefore),
                        dataAfter: toDetailData(res.data.data?.dataAfter),
                    }
                }))
            }
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleValueChangeForChangeRequest = (name, value, type) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            dataChangeRequest: {
                ...prevState.dataChangeRequest,
                [type]: {
                    ...prevState.dataChangeRequest[type],
                    [name]: value
                }
            }
        }))
    }

    handleOnSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    }

    handleSimpanAlertVisibility = () => {
        if (!this.props.validate()) {
            this.handleGeneralAlertVisibility();
            return;
        }

        this.setState((prevState) => ({
            ...prevState,
            simpanAlertVisible: !prevState.simpanAlertVisible
        }));
    }

    handleGeneralAlertVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            generalAlertVisible: !prevState.generalAlertVisible
        }));
    }

    handleCancelAlertVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            cancelAlertVisible: !prevState.cancelAlertVisible
        }));
    }

    handleProcessAlertVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            processAlertVisible: !prevState.processAlertVisible
        }));
    }

    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.activeTab === "create_prospek" ? "Detail Data CDB" : "Detail Perubahan Data CDB"}
                    visible={this.props.state.detailVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <Tabs>
                                <TabList>
                                    <Tab>DATA KTP</Tab>
                                    <Tab>DATA TAMBAHAN</Tab>
                                    <Tab>DATA MEMBER</Tab>
                                    {this.props.activeTab === "create_prospek" && <Tab>DATA SYSTEM</Tab>}
                                </TabList>
                                <TabPanel key={"ktp"}>
                                    {this.props.activeTab === "create_prospek" ? (
                                        <CrmKTP
                                            {...this.props}
                                            options={this.state.options}
                                            box="CDB"
                                        />
                                    ) : (
                                        <>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>BEFORE</h4>
                                                </div>
                                            </div>
                                            <CrmKTP
                                                type="before"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataBefore}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataBefore")}
                                                options={this.state.options}
                                                box="CDB"
                                            />
                                            <SimpleSpacerLine/>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>AFTER</h4>
                                                </div>
                                            </div>
                                            <CrmKTP
                                                type="after"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataAfter}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataAfter")}
                                                options={this.state.options}
                                                box="CDB"
                                            />
                                        </>
                                    )}
                                </TabPanel>
                                <TabPanel key={"tambahan"}>
                                    {this.props.activeTab === "create_prospek" ? (
                                        <CrmTambahan
                                            {...this.props}
                                            options={this.state.options}
                                        />
                                    ) : (
                                        <>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>BEFORE</h4>
                                                </div>
                                            </div>
                                            <CrmTambahan
                                                type="before"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataBefore}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataBefore")}
                                                options={this.state.options}
                                            />
                                            <SimpleSpacerLine/>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>AFTER</h4>
                                                </div>
                                            </div>
                                            <CrmTambahan
                                                type="after"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataAfter}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataAfter")}
                                                options={this.state.options}
                                            />
                                        </>
                                    )}
                                </TabPanel>
                                <TabPanel key={"member"}>
                                    {this.props.activeTab === "create_prospek" ? (
                                        <CrmMember
                                            {...this.props}
                                            options={this.state.options}
                                            box="CDB"
                                        />
                                    ) : (
                                        <>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>BEFORE</h4>
                                                </div>
                                            </div>
                                            <CrmMember
                                                type="before"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataBefore}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataBefore")}
                                                options={this.state.options}
                                                box="CDB"
                                            />
                                            <SimpleSpacerLine/>
                                            <div className="margin-10px">
                                                <div className="txt-site txt-20 txt-main">
                                                    <h4>AFTER</h4>
                                                </div>
                                            </div>
                                            <CrmMember
                                                type="after"
                                                activityType="VIEW"
                                                controls={this.props.state.dataChangeRequest?.dataAfter}
                                                setValue={(name, value) => this.handleValueChangeForChangeRequest(name, value, "dataAfter")}
                                                options={this.state.options}
                                                box="CDB"
                                            />
                                        </>
                                    )}
                                </TabPanel>
                                {this.props.activeTab === "create_prospek" && (
                                    <TabPanel key={"system"}>
                                        <CrmSystem
                                            {...this.props}
                                            options={this.state.options}
                                            box="CDB"
                                        />
                                    </TabPanel>
                                )}
                            </Tabs>
                            {this.props.activityType === ACTIVITY_TYPE.UPDATE && this.props.activeTab === "create_prospek" && (
                                <FlexView style={{justifyContent: "right", marginTop: "20px", gap: "20px"}}>
                                    <SimpleButton
                                        text="SIMPAN"
                                        onClick={() => this.handleSimpanAlertVisibility()}
                                    />
                                </FlexView>
                            )}

                            {this.props.activityType === ACTIVITY_TYPE.VIEW && this.props.activeTab === "create_prospek" && (
                                <FlexView style={{justifyContent: "right", marginTop: "20px", gap: "20px"}}>
                                    <SimpleButton
                                        text="Close"
                                        onClick={() => this.props.onClickClose()}
                                    />
                                </FlexView>
                            )}

                            {this.props.activeTab !== "create_prospek" && (
                                <FlexView style={{justifyContent: "right", marginTop: "20px", gap: "20px"}}>
                                    <SimpleButton
                                        text="TOLAK"
                                        onClick={() => this.handleCancelAlertVisibility()}
                                    />
                                    <SimpleButton
                                        text="PROSES"
                                        onClick={() => this.handleProcessAlertVisibility()}
                                    />
                                </FlexView>
                            )}
                        </ModalContainer>
                    }
                />

                {this.state.simpanAlertVisible && (
                    <SimpleAlert
                        title={"Information"}
                        visible={this.state.simpanAlertVisible}
                        onClickClose={this.handleSimpanAlertVisibility}
                        content={"Anda melakukan perubahan pada DATA CUSTOMER dan proses ini akan diteruskan kepada proses Approval. Apakah anda yakin?"}
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleSimpanAlertVisibility}>Batal</SimpleButton>
                                <SimpleButton onClick={() => this.handleOnSubmit()}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.cancelAlertVisible && (
                    <SimpleAlert
                        title={"Information"}
                        visible={this.state.cancelAlertVisible}
                        onClickClose={this.handleCancelAlertVisibility}
                        content={
                            <FlexView column hAlignContent={"left"}>
                                <p style={{textAlign: "left"}}>Anda akan menolak pengajuan perubahan data yang dilakukan
                                    oleh: </p><br/>
                                <p>Member ID: {this.props.state.dataChangeRequest?.dataAfter.customerId?.value}</p>
                                <p>Nama: {this.props.state.dataChangeRequest?.dataAfter.name?.value}</p>
                                <p>NIK: {this.props.state.dataChangeRequest?.dataAfter.nik?.value}</p><br/>
                                <p>Apakah anda yakin?</p>
                            </FlexView>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleCancelAlertVisibility}>Batal</SimpleButton>
                                <SimpleButton
                                    onClick={() => this.props.onCancel(this.props.controls.nik?.value)}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.processAlertVisible && (
                    <SimpleAlert
                        title={"Information"}
                        visible={this.state.processAlertVisible}
                        onClickClose={this.handleProcessAlertVisibility}
                        content={
                            <FlexView column hAlignContent={"left"}>
                                <p>Pengajuan perubahan data dengan data: </p><br/>
                                <p>Member ID: {this.props.state.dataChangeRequest?.dataAfter.customerId?.value}</p>
                                <p>Nama: {this.props.state.dataChangeRequest?.dataAfter.name?.value}</p>
                                <p>NIK: {this.props.state.dataChangeRequest?.dataAfter.nik?.value}</p><br/>
                                <p>Akan diteruskan ke Approval. Apakah anda yakin?</p>
                            </FlexView>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleProcessAlertVisibility}>Batal</SimpleButton>
                                <SimpleButton
                                    onClick={() => this.props.onProcess(this.state.id)}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.generalAlertVisible && (
                    <SimpleAlert
                        title={"Information"}
                        visible={this.state.generalAlertVisible}
                        onClickClose={this.handleGeneralAlertVisibility}
                        content={"Ada isian yang belum diisi. Mohon periksa kembali."}
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleGeneralAlertVisibility}>OK</SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(withFormGroup(CrmCDBDetail));